module.exports = __webpack_public_path__ + "static/media/CLEAN&CLEAR.b1d33980.pdf";